import type { ConnectionTestResult, KlaviyoSettingsSummary, KlaviyoSettingsUpdateBody } from '@flux/shared';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client.js';
import { queryKeys } from '@/lib/query/keys.js';

/**
 * Couche réseau de l'onglet Paramètres → Klaviyo (`06` §11.4). La clé ne
 * revient jamais : seulement sa présence (`apiKeyConfigured`).
 */

export function fetchKlaviyoSettings(): Promise<KlaviyoSettingsSummary> {
  return apiFetch<KlaviyoSettingsSummary>('/api/klaviyo/settings');
}

export function updateKlaviyoSettings(body: KlaviyoSettingsUpdateBody): Promise<KlaviyoSettingsSummary> {
  return apiFetch<KlaviyoSettingsSummary>('/api/klaviyo/settings', { method: 'PUT', body });
}

export function testKlaviyoConnection(): Promise<ConnectionTestResult> {
  return apiFetch<ConnectionTestResult>('/api/klaviyo/settings/test-connection', { method: 'POST' });
}

/** Résumé de l'intégration, partagé par Paramètres et les écrans qui en dépendent. */
export function useKlaviyoSummary() {
  return useQuery({ queryKey: queryKeys.klaviyoSettings.summary(), queryFn: fetchKlaviyoSettings });
}
